export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9548.e4bd39c8.jpg";